// filterQueryParams contains the available params specifically related to filter values.
// Having a separate enums seems to be the most clean and flexible solution for now (as we'll possibly need to localize this at some point).
export enum CarFilterQueryParam {
    Brand = "brands", // Important that it's plural as otherwise it will interfere with the brand = "lexus" | "toyota" param.
    Model = "model",
    FuelType = "fuelType",
    Category = "category",
    Equipment = "equipment",
    Seats = "seats",
    Doors = "doors",
    PowerOutput = "powerOutput",
    Year = "year",
    Transmission = "transmission",
    Colour = "colour",
    EcoLabel = "ecoLabel",
    Warranty = "warranty",
    License = "license",
    Mileage = "mileage",
    Location = "location",
    Price = "price",
    VehicleStatus = "vehicleStatus",
    EfficiencyClass = "efficiencyClass",
    Deliverable = "deliverable",
    ModelYear = "modelYear",
    BodyStyle = "bodyStyle",
    DriveType = "driveType",
    Ownership = "ownership",
    CarType = "carType",
}

export type CarFilterFilterOverrideType = {
    key: CarFilterQueryParam;
    value: string;
};
